import PropTypes from 'prop-types';

export const watermarkType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  emailAddress: PropTypes.string.isRequired,
});



// WEBPACK FOOTER //
// ./components/molecules/Watermark/prop-types.js